import { GovField } from "@publicMirage/components/govReact/GovField";
import { ErrorText, FormGroup, H3, LabelText } from "govuk-react";
import React, { memo } from "react";
import { useForm } from "../hooks/formContext";
import { PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes, PrePpWlNonResidentialChangeOfUseTypes } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";
import { PrPpWlFormManager } from "@shared/prePublicPortalWestLindsay/managers/PrePpWlFormManager";

export const RetailOfficeIndustrialDevelopmentType = memo(() => {
    const { toFieldProps, formState, getFieldProp } = useForm();
    const { developmentScale } = formState;
    const typeOfRetailDevelopment = developmentScale.value;
    const showAdditionalGrossFloorSpace = PrPpWlFormManager.isAdditionalGrossFloorSpaceType(typeOfRetailDevelopment);
    const errorMsg = getFieldProp("developmentScale", "errorMsg");

    return (
        <>
            <H3>Type C: Retail / Office / Industrial Developments</H3>
            <FormGroup error={!!errorMsg}>
                <LabelText className="required">Scale of development</LabelText>
                <ErrorText>{errorMsg}</ErrorText>
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes.EXTENSION)} label="Extension" />
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes.NEW_BUILD)} label="New Build" />
                <GovField
                    {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes.CHANGE_OF_USE)}
                    label="Change of use (e.g. residential to retail)"
                />
                <GovField
                    {...toFieldProps("developmentScale", "RADIO", PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes.ALTERATIONS)}
                    label="Alterations (e.g. shop fronts, pv panels, fences)"
                />
            </FormGroup>
            {showAdditionalGrossFloorSpace ? <GovField {...toFieldProps("additionalGrossFloorSpace", "TEXT")} /> : null}
            <NonResidentialChangeOfUseRadioButtons />
            {typeOfRetailDevelopment === PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes.ALTERATIONS ? (
                <GovField {...toFieldProps("alterationsDescription", "TEXTAREA")} />
            ) : null}
            <GovField {...toFieldProps("additionalFullTimeEmployees", "TEXT")} />
            <GovField {...toFieldProps("additionalPartTimeEmployees", "TEXT")} />
            <GovField {...toFieldProps("estimatedNumberOfVehicularTrips", "TEXT")} />
        </>
    );
});

const NonResidentialChangeOfUseRadioButtons = memo(() => {
    const { toFieldProps, formState, getFieldProp } = useForm();
    const { developmentScale } = formState;
    const typeOfRetailDevelopment = developmentScale.value;
    const errorMsg = getFieldProp("nonResidentialChangeOfUse", "errorMsg");
    if (typeOfRetailDevelopment !== PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes.CHANGE_OF_USE) {
        return null;
    }
    return (
        <FormGroup error={!!errorMsg}>
            <LabelText className="required">Non-residential change of use (including siting of caravans) for sites</LabelText>
            <ErrorText>{errorMsg}</ErrorText>
            <GovField {...toFieldProps("nonResidentialChangeOfUse", "RADIO", PrePpWlNonResidentialChangeOfUseTypes.UNDER_1000)} label="Under 1000sq m/1ha (gross)" />
            <GovField {...toFieldProps("nonResidentialChangeOfUse", "RADIO", PrePpWlNonResidentialChangeOfUseTypes.OVER_1000)} label="Over 1000sq m/1ha (gross)" />
        </FormGroup>
    );
});
